import { Navigate, useTypedParams } from '@sorare/routing';
import { ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport/index.ts';

import type { PageParams } from './__generated__/routeParams.ts';

const LegacySelectTeamPage = () => {
  const { slug } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG,
        { params: { slug } }
      )}
      keepSearchParams
      replace
    />
  );
};

export default LegacySelectTeamPage;
